export let ServiceTemplateStatus;

(function (ServiceTemplateStatus) {
  ServiceTemplateStatus["Active"] = "active";
  ServiceTemplateStatus["Deleted"] = "deleted";
})(ServiceTemplateStatus || (ServiceTemplateStatus = {}));